import React, { ComponentPropsWithRef, FC, PropsWithChildren } from 'react';
import { ClippedImage } from '@components/ClippedImage/ClippedImage.component';
import { DownloadAppButtons } from '@components/LandingPageApp/DownloadAppButtons/DownloadAppButtons.component';
import { Text } from '@components/Text/Text.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { ClippedImageStyle } from '@utils/images';
import classnames from 'classnames';
import styles from './LandingPageAppHeader.module.scss';

type Props = ComponentPropsWithRef<'header'> & {
  handleTagClick: (clickName: string, event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const LandingPageAppHeader: FC<PropsWithChildren<Props>> = ({ className, handleTagClick, ...rest }) => {
  const isMobile = useIsBreakpointDown(Breakpoint.m);
  const rootClass = classnames(styles['plc-landing-header'], 'wrapper-s ', className);
  return (
    <>
      <ClippedImage alt="" clipStyle={ClippedImageStyle.rectangle} plcSrc={{ src: 'plv', type: 'local' }} />
      <header className={rootClass} {...rest}>
        <Text i18nKey="landing-app.title" tag="h2" variant={isMobile ? 'h3' : 'h2'} />
        <div>
          <Text i18nKey="landing-app.desc" variant="p" />
          <DownloadAppButtons handleTagClick={handleTagClick} />
        </div>
      </header>
    </>
  );
};

export { LandingPageAppHeader };
